import { ReducerFnInterface } from '@context/type';
import { FiltersStateInterface } from './filters.type';

export const FiltersReducer: ReducerFnInterface<FiltersStateInterface> = (
  state,
  { type, payload },
) => {
  switch (type) {
    case 'filters_status_update':
      return {
        ...state,
        status: payload.status,
      };
    case 'filter_search_update':
      return {
        ...state,
        search: payload.search,
      };
    case 'filter_search_active':
      return {
        ...state,
        isSearching: payload.isSearching,
      };
    default:
      return state;
  }
};

FiltersReducer.key = 'filters';
FiltersReducer.initialState = {
  status: [],
  search: '',
  isSearching: false,
};
